// Case-insensitive substring match against the item's search strings.
export function itemMatchesQuery(item, query, getItemTitle) {
  return searchStrings(item, getItemTitle).some((text) => text.toLowerCase().includes(query));
}

// The strings a query is matched against, primary first. Normally the item's
// title plus any extra `keywords` (a string or array of strings) — keywords let
// a host make an item findable by text it does not display, e.g. an
// ASCII-folded "Jose" carried for a "José" whose title keeps its diacritics.
// An item carrying `searchText` is matched against that string only: it
// replaces the title (and keywords) as the searchable text, for hosts whose
// vocabulary augments a display label with a differing match string (the
// legacy events omnisearch `matchValue` semantics).
export function searchStrings(item, getItemTitle) {
  const { searchText } = item ?? {};
  if (typeof searchText === "string") {
    return [searchText];
  }
  return [getItemTitle(item) ?? "", ...keywordList(item)];
}

// Normalise an item's `keywords` (string | array | absent) to a string array.
export function keywordList(item) {
  const { keywords } = item ?? {};
  if (keywords == null) {
    return [];
  }
  return (Array.isArray(keywords) ? keywords : [keywords]).filter((keyword) => typeof keyword === "string");
}

// Coerce a `maxResults` value (number | numeric string | undefined) to a positive
// integer cap, or null for "no limit".
export function normalizeLimit(maxResults) {
  const n = Number(maxResults);
  return Number.isFinite(n) && n > 0 ? Math.floor(n) : null;
}
